export const policies = [
  {
    id: 1,
    title: "Recruitment and Hiring Procedures",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      images: [],
      sections: [
        {
          heading: "Recruitment and Hiring Procedures",
          text: "Human Resources (HR) plays a crucial role in recruiting by managing the process of attracting, selecting, and hiring the right candidates for job openings within an organization. HR ensures that the recruitment process is efficient, compliant with laws, and aligned with the company's goals and culture. From sourcing candidates to onboarding new hires, HR is essential in building a strong workforce that drives the organization's success."
        },
        {
          heading: "Recruitment and Selection",
          text: "The recruitment and selection process are crucial to get the right people in the right position at MARABES GROUP. To ensure that this process is fair, transparent, and effective, the following steps are taken:"
        },
        {
          heading: "Step 1: Finding Candidates",
          subheading: "Identifying the platforms:",
          text: "We use a variety of platforms to reach potential candidates, such as:",
          list: ["Instagram", "LinkedIn", "Facebook Ads", "Indeed", "Referrals from current employees, which often help us discover great talent"]
        },
        {
          subheading: "Receiving applications:",
          text: "Once job postings are live, we start receiving applications from a wide range of sources. These channels help us connect with both active and passive job seekers, expanding our reach and increasing the visibility of our opportunities."
        },
        {
          heading: "Step 2: Screening the Candidates",
          subheading: "Screening Applications",
          text: "We carefully shift through the applications to identify candidates who meet the required skills and qualifications.",
          subsections: [
            {
              subheading: "Initial Phone Call",
              text: "After reviewing resumes and applications, I conduct an initial phone call with potential candidates. The purpose of this call is to:",
              list: [
                "Confirm their availability and interest in the role",
                "Get a sense of their personality",
                "Verify key details such as their current situation, experience, and expectations"
              ]
            }
          ]
        },
        {
          heading: "Step 3: First Interview - Online Video Call",
          text: "First Interview the two of us (WhatsApp Video). If a candidate passes the initial screening, we move to the first interview, typically conducted via WhatsApp video call. During this interview:",
          subsections: [
            {
              text: "Ask them what they know about MARABES GROUP: This helps us see how much research they've done and how well they understand our mission and values."
            },
            {
              text: "What attracted them to our company: This question helps us understand why they want to join us and what aspects of the company appeal to them."
            },
            {
              subheading: "Ask general questions - Cover basic details:",
              list: ["Age", "Marital status (single, engaged, married)", "Education", "Experience", "Location", "Future plans", "Salary expectations"]
            },
            {
              subheading: "Ask specific questions:",
              text: "Depending on the conversation, I might dive deeper into their experience or skills, asking them to elaborate on past projects or roles."
            },
            {
              subheading: "Notice personality:",
              text: "Evaluate their communication style and determine if their values align with our company culture like:",
              list: ["Communication Skills", "Professionalism", "Confidence", "Attitude and Positivity"]
            },
            {
              subheading: "Give candidates a turn:",
              text: "Allow them to ask any questions they might have about the role or the company"
            }
          ]
        },
        {
          heading: "Step 4: Second Interview",
          text: "At this stage, the candidate meets in person with the manager and team lead. The focus is on evaluating the candidate more deeply through the following steps:",
          subsections: [
            {
              subheading: "Decision-Making:",
              text: "Understand how the candidate handles challenges and makes decisions."
            },
            {
              subheading: "Adaptability:",
              text: "Assess the candidate's ability to overcome obstacles and adjust to new situations."
            },
            {
              subheading: "Team Fit:",
              text: "Ensure the candidate's skills and values align with the team's needs and the role's requirement."
            }
          ]
        },
        {
          heading: "Sometimes Third Interview",
          text: "If there are still uncertainties after the second interview, or if the role requires highly specialized skills, we proceed with a third interview."
        },
        {
          heading: "Step 5: Offering the Job",
          text: "After finalizing our decision, we officially offer the candidate the position. This step involves the following:",
          subsections: [
            {
              subheading: "Communication via WhatsApp:",
              text: "For approved candidates, we first send the offer letter via WhatsApp to inform them of the positive outcome. For candidates who are not selected, we send a polite rejection message via WhatsApp without making a call.",
              list: ["Offer Letter", "Rejection Letter"]
            },
            {
              subheading: "Call the approved candidate",
              text: "After sending the WhatsApp message, we personally call the approved candidate to discuss important details such as:",
              list: ["Contract type", "Salary", "Start date", "Working days and hours", "Vacation and Holidays"]
            },
            {
              subheading: "Required documents:",
              list: ["ID", "Education diplomas", "Training certificates", "Certificate of good Conduct", "ANAPEC certificate"]
            },
            {
              subheading: "Explain company protocols:",
              text: "Provide the candidate with an overview of company protocols so they know what to expect when they join."
            }
          ]
        }
      ]
    }
  },
  {
    id: 2,
    title: "Employee Evaluation Procedure",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "Employee Evaluation Procedure – MARABES GROUP",
          text: "At MARABES, we believe it is important to support our employees in their professional development in a transparent and structured manner. By reviewing progress annually, we create space for reflection, recognition, and growth. This evaluation procedure provides insight into performance, behavior, attendance, and learning ability, and enables both the employee and the direct supervisor to work together on goals and areas for improvement."
        },
        {
          text: "For new employees, we follow a more intensive process: during the first 12 months of employment, there are four evaluation moments after 1, 3, 6, and 12 months. This allows us to monitor development more closely and offer more targeted guidance."
        },
        {
          heading: "Evaluation Frequency",
          list: ["Existing employees: Annually in December", "New employees: Four times during the first year"]
        },
        {
          heading: "Evaluation Period",
          text: "January 1st to December 31st"
        },
        {
          heading: "Who is Involved?",
          list: ["The direct supervisor", "HR department", "The management team", "The employee"]
        },
        {
          heading: "Evaluation Criteria",
          text: "The following areas are assessed:",
          subsections: [
            {
              subheading: "Attendance & Punctuality",
              text: "Authorized/unauthorized absences, sick leave, arrival and departure times."
            },
            {
              subheading: "Work Performance",
              text: "Work quality, productivity, meeting deadlines and achieving goals."
            },
            {
              subheading: "Behavior & Attitude",
              text: "Respect for colleagues and the organization, professionalism, receptiveness to feedback."
            },
            {
              subheading: "Teamwork & Communication",
              text: "Collaboration within the team, communication skills, handling of conflicts."
            },
            {
              subheading: "Responsibility & Initiative",
              text: "Ability to work independently, showing initiative, problem-solving skills, time management."
            },
            {
              subheading: "Skills & Development",
              text: "Acquired competencies, participation in training, willingness to take on new tasks or roles."
            },
            {
              subheading: "Self-Evaluation (optional)",
              text: "The employee's own reflection on their performance, strengths, and areas for improvement."
            }
          ]
        },
        {
          heading: "Steps in the Evaluation Process",
          subsections: [
            {
              subheading: "1. Preparation by HR",
              text: "HR provides the standard evaluation form and the planning schedule to all supervisors."
            },
            {
              subheading: "2. Evaluation by the Supervisor",
              text: "The direct supervisor completes the evaluation form for the employee."
            },
            {
              subheading: "3. Review with HR and Management",
              text: "The completed evaluation is discussed between the supervisor, HR, and management to form a shared assessment."
            },
            {
              subheading: "4. Evaluation Meeting with the Employee",
              text: "The supervisor discusses the evaluation with the employee and HR manager, including feedback and employee responses."
            },
            {
              subheading: "5. Creating an Action Plan",
              text: "Together with the employee, a concrete action plan is created with clear goals, timelines, and any necessary support through coaching or training."
            },
            {
              subheading: "6. Documentation and Follow-up",
              text: "The evaluation and action plan are stored in the employee's HR file. HR monitors any follow-up actions or agreements and schedules interim check-ins if needed."
            }
          ]
        },
        {
          heading: "Confidentiality & Record-Keeping",
          text: "All evaluation documents are handled confidentially and stored in the employee's personal HR file. Only the direct supervisor, HR, and management have access to this information."
        }
      ]
    }
  },
  {
    id: 3,
    title: "Employee's Absence Guideline",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "Personal Commitment Leave",
          list: [
            "Absence for personal reasons must be requested at least 48 hours in advance by email.",
            "In urgent or unforeseen situations, HR must be informed by any available means.",
            "Any absence exceeding 2 hours will be considered as a full day of leave.",
            "Additional cases will be reviewed and handled on a case-by-case basis."
          ]
        },
        {
          heading: "Sick Leave",
          list: [
            "A medical certificate must be submitted within 48 hours of the absence.",
            "If a medical certificate is provided, the absence will be treated as sick leave, and the corresponding days will be deducted from the salary.",
            "If no medical certificate is submitted, the absence will be considered as a day off and deducted from the employee's annual vacation.",
            "If the employee has no remaining vacation days, the absence will be deducted directly from the salary."
          ]
        },
        {
          heading: "Emergency Leave",
          list: [
            "Employees must notify their supervisor immediately in the case of an emergency.",
            "Emergency leave may be paid or unpaid based on the situation."
          ]
        }
      ]
    }
  },
  {
    id: 4,
    title: "Guidelines for Employee Warnings and Corrective Actions",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "Guidelines for Employee Warnings and Corrective Actions",
          text: "At Marabes Group, we have a clear process to handle cases when employees are late or don't follow office policies:",
          list: [
            "First, we give a verbal warning. If the employee repeats the issue, they can get up to three verbal warnings. Each warning is documented so we keep track.",
            "If the problem continues after that, we send written warnings by email usually up to two times. The employee is asked to acknowledge these warnings.",
            "If there's still no improvement, we inform the manager, who then schedules a formal meeting with the employee to discuss the situation and decide on next steps."
          ]
        },
        {
          text: "This approach helps us keep things fair and gives everyone a chance to improve before taking more serious action."
        }
      ]
    }
  },
  {
    id: 5,
    title: "Hiring and Onboarding Guidelines",
    startDate: "2025-09-10",
    endDate: "2025-09-29",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "1. Start Date Assignment",
          text: "To ensure a smooth and organized onboarding process, all new employees must start on one of the following dates:",
          list: ["The first Monday of the month", "The third Monday of the month"]
        },
        {
          text: "Important: All employees must begin on a Monday. If the first or third week does not start with a Monday, the start date will be moved to the following Monday."
        },
        {
          text: "✓ Candidates will not be permitted to start without completing all required documentation. This schedule helps the team prepare in advance and ensures a structured and unified onboarding experience."
        },
        {
          heading: "2. HR Notification",
          text: "HR needs to send the agenda, including the information of the candidates, to the responsible managers (the Managers of Nador and Tangier, Marabes Academy, the IT Department, and the Planning Team) at least one week prior to the new employees' start date."
        },
        {
          text: "This communication helps all parties prepare in advance and ensures a smooth and well organized first day for the new employees."
        }
      ]
    }
  },
  {
    id: 6,
    title: "Offboarding Guidelines",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "4.2.1. Employee Resignation",
          text: "Notification The offboarding process starts when the employee formally informs their manager or team leader of their decision to resign. The employee is required to provide at least one month's notice before their last working day. This notice must be given in writing, through an email or formal resignation letter."
        },
        {
          text: "The resignation email must be sent to the managers of Nador and Tangier, with the HR department included in CC."
        },
        {
          heading: "4.2.2. HR Communication to Departments",
          text: "HR then informs all relevant departments such as IT, Planning, and Marabes Academy about the employee's departure, and ensures that all managers are notified via email. This information is also shared in the HR WhatsApp group."
        },
        {
          heading: "4.2.3. Delegation of Tasks",
          text: "Before officially submitting the resignation, the employee works with their manager to delegate their tasks and responsibilities to colleagues, ensuring continuity and smooth workflow. handover is prepared to assist those taking over."
        },
        {
          heading: "4.2.4. Legal Documentation and Clearance",
          text: "The employee completes the necessary clearance process coordinated by HR to finalize the administrative aspects of their departure and confirm the return of company property."
        },
        {
          heading: "4.2.5. Final Handover and Resignation Submission",
          text: "A detailed. The employee submits the final resignation if not done earlier, completes any outstanding work, and formally concludes the handover process to avoid any loose ends."
        },
        {
          heading: "4.2.6. Internal Communication and Team Alignment",
          text: "The manager communicates with the team to confirm task delegation, update points of contact, and ensure all responsibilities are clearly assigned to avoid disruptions."
        },
        {
          heading: "4.2.7. Post-Departure Actions",
          text: "After departure, HR conducts an exit interview, IT revokes access rights, Finance processes final payments, and the manager oversees the smooth transition of responsibilities. Employee records are archived per company policy."
        },
        {
          heading: "4.2.8. Departure Information Recording",
          text: "All relevant details of the employee's departure including notice period, last working day, handover status, and clearance completion are recorded in a shared Excel spreadsheet. This document is accessible to the entire management team for tracking and reference purposes."
        },
        {
          heading: "4.2.9. Final Documents Provided to the Employee",
          text: "A Certificate of Internship or Certificate of Employment, depending on the type of contract. This document is signed by the direct manager (see Attachment 5 for the template). Their final payslip, provided along with the certificate."
        }
      ]
    }
  },
  {
    id: 7,
    title: "Vacation Request Protocol",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "Vacation Request Protocol - MARABES GROUP",
          text: "To ensure smooth operations and effective team coordination, MARABES has implemented a clear vacation request process. All employees are required to follow the steps below carefully when requesting time off."
        },
        {
          text: "Please use the attached form \"Vacation Request Form – MARABES\" when submitting your request. This form must be fully completed and included in your email submission."
        },
        {
          heading: "1. Planning and Notice Period",
          list: [
            "Employees are encouraged to plan their vacation starting in January.",
            "Vacation requests must be submitted at least 3 weeks before the planned leave."
          ]
        },
        {
          heading: "2. Submitting Your Request",
          text: "The vacation request must be submitted as follows:",
          subsections: [
            {
              subheading: "Step 1: Complete the \"Vacation Request Form – MARABES\" in full, including:",
              list: [
                "Start and end dates of the vacation",
                "Total number of vacation days",
                "Vacation period (e.g., Week 32 / August 5–9)",
                "Name of the backup colleague during your absence"
              ]
            },
            {
              subheading: "Step 2: Send an email with the completed form attached to the following recipients:",
              list: [
                "Your Managers, Account Manager, Project Manager, and Quality Reviewer",
                "Always CC HR at hr@marabes.nl"
              ],
              text: "The email must clearly state the vacation period, total number of days, and the name of the backup colleague."
            },
            {
              subheading: "Step 3: After HR receives the manager's response",
              text: "(either in person, via WhatsApp, or email), HR will then send an official confirmation email to the employee, confirming whether the vacation request is approved or declined."
            }
          ]
        },
        {
          heading: "3. Ensure Proper Handover",
          text: "Before the vacation begins, the employee must:",
          list: [
            "Brief the backup colleague on current tasks and deadlines",
            "Share any necessary documents, tools, or login credentials",
            "Ensure all supervisors are informed of the backup contact during the absence"
          ]
        },
        {
          heading: "4. Final Steps",
          list: [
            "HR will verify that all required steps have been followed and the form has been submitted",
            "All vacation requests will be shared with the management team via WhatsApp"
          ]
        },
        {
          text: "Note: Requests that are incomplete or submitted late may be rejected."
        }
      ]
    }
  },
  {
    id: 8,
    title: "Fingerprint Checkpoint Guidelines",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "Working Hours",
          list: [
            "Start Time: 8:30 AM",
            "End Time: 5:30 PM",
            "Break Duration: 1 hour (45 minutes for lunch, 15 minutes for prayers)"
          ]
        },
        {
          heading: "Check-in and Check-out Procedures",
          subsections: [
            {
              subheading: "✓ Morning Check-in",
              list: [
                "All employees must use the fingerprint system to check in before 8:30 AM.",
                "Late arrivals (after 8:30 AM) will be recorded and addressed according to company policy."
              ]
            },
            {
              subheading: "✓ End-of-Day Check-out",
              list: [
                "Employees must check out using the fingerprint system after 5:30 PM.",
                "Unauthorized early departures will be noted and may lead to penalties."
              ]
            },
            {
              subheading: "✓ Break Check-in and Check-out",
              list: [
                "Employees are required to take a 1-hour break during the workday, consisting of: 45 minutes for lunch and 15 minutes for prayer",
                "Employees must check out before starting their break.",
                "Breaks can be taken in two parts (lunch and prayer) or as a single block.",
                "Do not exceed the total break time of 1 hour.",
                "Employees must check in after finishing their break."
              ]
            },
            {
              subheading: "✓ Missed Check-ins or Check-outs",
              list: [
                "If you forget to check in or out, inform HR immediately.",
                "Repeated failure to follow procedures may result in disciplinary action."
              ]
            }
          ]
        }
      ]
    }
  },
  {
    id: 9,
    title: "Office Policies and Expectations",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "OFFICE POLICIES AND EXPECTATIONS"
        },
        {
          heading: "Punctuality and Work Hours",
          subsections: [
            {
              subheading: "➢ Arrival Time",
              text: "Employees are expected to be at their desks by 8:30 AM, with work commencing promptly."
            },
            {
              subheading: "➢ Work Schedule",
              text: "The standard workday is 8 hours. Employees should complete their tasks efficiently and adhere to productivity standards.",
              list: [
                "The official working days are Monday through Saturday.",
                "Except during the VAT period and project deadlines, Saturdays are non-working days, compensating for national holidays that require us to work.",
                "Be on time and follow the designated work hours.",
                "Inform your manager of any potential delays or exceptions in advance"
              ]
            }
          ]
        },
        {
          heading: "Breaks",
          subsections: [
            {
              subheading: "➢ Break Time",
              text: "You are entitled to a total of 1 hour of break time each workday.",
              list: [
                "45 minutes can be used for lunch or coffee breaks.",
                "15 minutes is reserved for prayer."
              ]
            },
            {
              subheading: "➢ Break Schedule",
              list: [
                "Group 1: 13:00 PM - 13:45 PM",
                "Group 2: 13:45 PM - 14:30 PM"
              ],
              text: "Efficiently manage your break time and avoid overlapping breaks with other groups."
            }
          ]
        },
        {
          heading: "Professional Attire - Dress Code",
          text: "Maintain a professional and classic appearance.",
          list: [
            "Traditional attire (e.g., jalaba, abaya) is not permitted.",
            "Choose light-colored, respectful clothing with minimal distractions.",
            "Ensure your hair is well-groomed and your personal hygiene is impeccable.",
            "Avoid wearing shorts, jeans, excessive accessories, and heavy makeup."
          ]
        },
        {
          heading: "Completion of Tasks",
          text: "Ensure all assigned tasks are completed before leaving the office for the day."
        },
        {
          heading: "Reporting Issues",
          text: "Report any difficulties affecting your productivity to the management team promptly."
        },
        {
          heading: "Communication Etiquette",
          list: [
            "Communicate respectfully and professionally.",
            "Respond to emails within 24 hours during business days.",
            "Use a professional tone and appropriate language in all written communications"
          ]
        },
        {
          heading: "Team Collaboration",
          text: "Support and collaborate with your team members as needed."
        },
        {
          heading: "Leave Policies",
          subsections: [
            {
              subheading: "➢ Vacation Leave",
              list: [
                "Submit vacation requests via email at least three weeks prior to the desired time off.",
                "You are entitled to 18 days of paid vacation per year.",
                "Ensure no two team members are on vacation simultaneously."
              ]
            },
            {
              subheading: "➢ Sick Leave",
              list: [
                "A medical certificate must be submitted within 48 hours of the absence.",
                "If a medical certificate is provided, the absence will be treated as sick leave, and the corresponding days will be deducted from the salary.",
                "If no medical certificate is submitted, the absence will be considered as a day off and deducted from the employee's annual vacation.",
                "If the employee has no remaining vacation days, the absence will be deducted directly from the salary."
              ]
            },
            {
              subheading: "➢ Personal Commitments",
              list: [
                "Absences for personal reasons must be requested at least 48 hours in advance by email.",
                "In urgent or unforeseen situations, HR must be informed by any available means.",
                "Any absence exceeding 2 hours will be considered as a full day of leave.",
                "Additional cases will be reviewed and handled on a case-by-case basis."
              ]
            },
            {
              subheading: "➢ Emergency Leave",
              list: [
                "Notify your supervisor immediately in case of an emergency.",
                "Emergency leave may be paid or unpaid based on the situation."
              ]
            },
            {
              subheading: "➢ Absence Reporting",
              text: "Report any absences or tardiness to HR as soon as possible, even if only for a few minutes."
            }
          ]
        },
        {
          heading: "Task Delegation",
          text: "Before taking time off, delegate your tasks and deadlines to a colleague."
        },
        {
          heading: "Confidentiality",
          text: "Safeguard all company and customer information from unauthorized disclosure."
        },
        {
          heading: "Technology Use",
          subsections: [
            {
              subheading: "➢ Security",
              text: "Adhere to security protocols, including using strong passwords and reporting security breaches immediately."
            },
            {
              subheading: "➢ Software and Hardware",
              list: [
                "Use only company-approved software and hardware. Avoid unauthorized installations or device connections.",
                "Ensure all software is current with the latest updates and security patches."
              ]
            },
            {
              subheading: "➢ Data Protection",
              list: [
                "Regularly back up important data and encrypt sensitive information.",
                "Follow company policies for data retention and disposal."
              ]
            }
          ]
        },
        {
          heading: "Acceptable Use of Technology",
          subsections: [
            {
              subheading: "➢ Professional Use",
              text: "Use company computers and internet strictly for work-related purposes. Minimize personal use."
            },
            {
              subheading: "➢ Internet Browsing",
              text: "Refrain from visiting inappropriate sites or downloading illegal content."
            },
            {
              subheading: "➢ Network Usage",
              text: "Avoid activities that could harm the network or access non-work-related streaming services during office hours."
            }
          ]
        },
        {
          heading: "Anti-Discrimination and Harassment",
          subsections: [
            {
              subheading: "➢ Commitment",
              text: "We maintain a zero-tolerance policy for discrimination and harassment."
            },
            {
              subheading: "➢ Action",
              text: "All allegations will be investigated thoroughly, with disciplinary action taken if necessary."
            },
            {
              subheading: "➢ Reporting",
              text: "Report any incidents of discrimination or harassment to your supervisor/HR."
            },
            {
              subheading: "➢ Prohibited Conduct",
              text: "Discrimination based on race, gender, national origin, age, disability, or other protected characteristics is strictly prohibited."
            }
          ]
        },
        {
          heading: "Phone Use",
          list: [
            "It is not permitted to use your phone during work hours for social media and other personal purposes.",
            "The phone must not be on your desk or visible; it should be stored in your bag or in your locker.",
            "WhatsApp may only be used via the browser on your screen and solely for work-related purposes.",
            "Management and supervisors are allowed to use phones for work-related purposes."
          ]
        },
        {
          heading: "Conflict Resolution",
          text: "Address conflicts professionally and promptly"
        },
        {
          heading: "Feedback and Suggestions",
          text: "Provide constructive feedback and suggestions to improve work processes."
        },
        {
          heading: "Health and Safety",
          text: "Adhere to health and safety guidelines and report any hazards immediately."
        },
        {
          heading: "Client Interaction",
          text: "Interact with clients courteously and professionally. Ensure high client satisfaction"
        },
        {
          heading: "Company Representation",
          text: "Represent the company with professionalism both inside and outside the workplace"
        },
        {
          heading: "Time Management",
          text: "Manage your time effectively, prioritize tasks, and meet deadlines"
        }
      ]
    }
  },
  {
    id: 10,
    title: "Dress Code",
    startDate: "2025-09-10",
    endDate: "2025-09-27",
    category: "OFFICE_POLICY",
    content: {
      images: [
        { src: "https://axopeople.blob.core.windows.net/policy-images/01235c4a-7169-4c83-ad0e-cacdc12e30f5_Slide4.JPG", caption: "Dress Code Example 1" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/9303af05-6d7c-44f8-acb7-fc52e7ba9a74_Slide5.JPG", caption: "Dress Code Example 2" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/e3f9b513-f9d7-4d77-8e99-5b9b374aaa78_Slide6.JPG", caption: "Dress Code Example 3" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/76a21b79-06d4-449f-8731-75cebf7c9055_Slide7.JPG", caption: "Dress Code Example 4" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/9ed3a991-df13-444a-8b6d-ee0275c1fd3b_Slide8.JPG", caption: "Dress Code Example 5" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/1ede2354-f157-4c06-a754-d81f650bedd3_Slide9.JPG", caption: "Dress Code Example 6" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/e02e2531-cdaa-4eaf-b4ec-b43ea911fa90_Slide1.JPG", caption: "Dress Code Example 7" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/ca7354c7-445f-405e-b085-1b0d00ba7542_Slide2.JPG", caption: "Dress Code Example 8" },
        { src: "https://axopeople.blob.core.windows.net/policy-images/b1db5b77-7b4a-44d7-8025-c175bd2ff2d4_Slide3.JPG", caption: "Dress Code Example 9" },
      ],
    }
  },
  {
    id: 11,
    title: "Employee Leave Guidelines",
    startDate: "2025-10-01",
    endDate: "2025-10-15",
    category: "OFFICE_POLICY",
    content: {
      sections: [
        {
          heading: "Vacation Leave",
          subsections: [
            {
              subheading: "➢ Plan Ahead:",
              text: " Vacations should be planned at the beginning of the calendar year to help with team scheduling and workload distribution."
            },
            {
              subheading: "➢ Eligibility:",
              text: "Employees are not eligible to take vacation leave until they have completed six (6) months of continuous employment."
            },
            {
              subheading: "➢ Entitlement:",
              text: " Each employee is entitled to 18 days of paid vacation per year."
            },
            {
              subheading: "➢ Request Timeline:",
              text: "Submit vacation requests via email at least three (3) weeks prior to the desired time off."
            },
            { 
              subheading: "➢ Team Coordination:",
              text: " No two team members (Same team, positions and project) may be on vacation at the same time unless explicitly approved by management."
            }
          ]
        },
        {
          heading: "Emergency Leave",
          subsections: [
            {
              subheading: "➢ Immediate Notification:",
              text: "Inform your supervisor immediately in case of an emergency."
            },
            {
              subheading: "➢ Paid or Unpaid:",
              text: "Emergency leave may be paid or unpaid, based on the situation and subject to HR review."
            },
            {
              subheading: "➢ Entitlement:",
              text: "Documentation may be required depending on the nature and duration of the leave. (eg. A medical certificate is required for any absence exceeding three (3) consecutive days due to illness.)"
            },
          ]
        },
        {
          heading: "Absence Reporting",
          text: "Report all absences or tardiness - even brief ones - to HR as soon as possible using the designated communication method (e.g., phone, email...)."
        },
        {
          heading: "Personal Commitments",
          list: [
            "Requests for time off due to personal commitments must be submitted at least one (1) week in advance.",
            "Approval is subject to team workload, critical business needs, and manager discretion.",
          ]
        },
        { heading: "Sick Leave",
          list: [
            "All leave must be approved in advance unless due to an unforeseen emergency.",
            "Failure to comply with these guidelines may result in the leave being considered unauthorized.",
            "Leave balances and approval records are maintained by HR."
          ]
        }
      ]
    }
  }
];
